import "./advertisements.css";
import { FaEdit, FaTimes   } from "react-icons/fa";

function Advertisements () {

  return (
    <>
      <div className="headbands-container">

        <div className="headbands-headers">
          <p className="title">Texto</p>
          <p className="actions">Acciones</p>
        </div>

        <div className="headbands-item">
          <p>Esto es solo un texto de pruebaaaaa</p>
          <div className="btns-content">
            <button className="edit-btn">
              <FaEdit />
            </button>
            <button className="delete-btn">
              <FaTimes />
            </button>
          </div>
        </div>

      </div>
      advertisements works!
    </>
  )
}

export default Advertisements;